import { useField, useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import CheckboxListField from "../checkbox-list-field/checkbox-list-field";
import arrowIcon from '../../images/Down Arrow.svg';
import Label from "../label/label";
import { addCustomFieldMetaData } from "../../utilities/formFields";
import OutsideClick from "../outside-click/outside-click";
import { generateFieldId } from '../../utilities/GenerateFieldId'
import { requiredSelectionValidation } from "../../utilities/Validation";
import { useLocale } from "../../contexts/localeContext";

interface SettingCheckboxListFieldProps {
    accessor: string;
    displayName: string | undefined;
    isCard?: boolean;
    options: any[];
    detailTypeId?: number;
    isSummation?: boolean;
    required?: boolean;
}

const SettingCheckboxListField: FC<SettingCheckboxListFieldProps> = ({ accessor, displayName, isCard = false, options, detailTypeId = undefined, isSummation = false, required = false }) => {
    const [open, setOpen] = useState(false);
    const className = 'text-gray-900';
    const { errors, values, setFieldValue } = useFormikContext();
    const [selectionLabel, setSelectionLabel] = useState('-');
    const { translate } = useLocale();
    const [field] = useField({ name: accessor, validate: required ? (value) => requiredSelectionValidation(value, translate) : undefined });

    useEffect(() => {
        addCustomFieldMetaData(detailTypeId, values, accessor, setFieldValue);
    }, [])

    return <div className="flex flex-col flex-1 pr-6 mb-2">
        <div className="flex flex-row justify-between" id={generateFieldId(accessor, 'CheckBoxLabel')}>
            <Label htmlFor={accessor}
                required={required}
                className="text-xs text-gray-600 mt-1">{displayName}:</Label>
            {(() => {
                const error = accessor.split('.').reduce((previous, current) => { return previous?.[current] }
                    , errors as any);
                if (error) {
                    return <span className='text-red-600 text-xs'>{error}</span>
                } else {
                    return null;
                }
            })()}
        </div>
        <OutsideClick onClick={() => setOpen(false)}>
            <button type="button"
                className={`bg-gray-input w-full p-1 px-2 text-left flex flex-row justify-between text-sm min-width-48 ${className}`}
                onClick={() => setOpen(!open)}>
                <span>{selectionLabel}</span>
                <img className="pl-2 select-field--arrow" src={arrowIcon} alt=""></img>
            </button>
            <div className="flex flex-1 relative z-50 ">
                <div className={`text-sm max-w-xs overflow-visible absolute block border shadow-md rounded-b-sm bg-white ml-4 pl-1 pt-2 pr-2 pb-2 ${open ? 'w-auto h-auto' : 'hidden'}`} id={generateFieldId(accessor, 'CheckBox')}>
                        <CheckboxListField
                            name={accessor}
                            compact={true}
                            options={options.sort((a, b) => a.ordinal - b.ordinal)
                                .map((option) => {
                                    return { label: option.name, value: option.id }
                                })}
                            isSummation={isSummation}
                            updateSelectionLabel={setSelectionLabel}>
                        </CheckboxListField>
                </div>
            </div>

        </OutsideClick>
    </div>
}

export default SettingCheckboxListField;
